import { useState } from "react";
import { Box, Typography } from "@mui/material";
import toast from "react-hot-toast";
import { CustomDialog } from "../../../../components/customDialog/CustomDialog";
import { RenderInputByTypeMobile } from "../../../../components/formGroupGenerator/RenderInputByTypeMobile";

export const DialogDesestimarLiquidacion = ({
    open,
    setOpen,
    cantidadSeleccionada,
    onConfirmar,
    loading
}) => {
    const [justificacion, setJustificacion] = useState('');

    const handleChange = (_, value) => setJustificacion(value);

    const handleClose = () => {
        setOpen(false);
        setJustificacion('');
    };

    const handleAccept = async () => {
        if (!justificacion?.trim()) {
            toast.error('Debe ingresar una justificación');
            return;
        }

        const ok = await onConfirmar(justificacion.trim());
        if (ok) handleClose();
    };

    return (
        <CustomDialog
            open={open}
            fullWidth
            boldDialogTitle
            maxWidth='sm'
            dialogTitle='Desestimar'
            onCancel={handleClose}
            onAccept={handleAccept}
            cancelText='Cerrar'
            cancelDisabled={loading}
            acceptLoading={loading}
            onBackdropClick={loading ? () => { } : null} //Si está cargando, no permitir cerrar haciendo click fuera del diálogo
        >
            <Box sx={{ mt: 1 }}>
                {cantidadSeleccionada > 0 && (
                    <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
                        Se desestimará{cantidadSeleccionada > 1 ? 'n' : ''} {cantidadSeleccionada} liquidación(es).
                    </Typography>
                )}
                <RenderInputByTypeMobile
                    input={{
                        displayName: 'Justificación de rechazo',
                        name: 'justificacion',
                        type: 'long_string'
                    }}
                    handleChange={handleChange}
                    value={justificacion}
                />
            </Box>
        </CustomDialog>
    );
};